// extracted by mini-css-extract-plugin
export default {"indicator":"ComplexityIndicator_indicator__6P1+7","dots":"ComplexityIndicator_dots__gH1Gq","dot":"ComplexityIndicator_dot__Bg8es","label":"ComplexityIndicator_label__-wyCy"};